import * as React from "preact";
import { JSX } from "preact";

export interface IconContext {
  color?: string;
  size?: string;
  class?: string;
  stroke?: string | JSX.SignalLike<string | undefined>; // allow overide stroke color "currentColor"
  fill?: string | JSX.SignalLike<string | undefined>; // allow overide fill color "currentColor"
  strokeWidth?:  number | string | JSX.SignalLike<number | string | undefined>; // allow overide strokeWidth default 0

  style?: JSX.CSSProperties;
  attr?: JSX.SVGAttributes<SVGSVGElement>;
}

export const defaultContext: IconContext = {
  color: undefined,
  size: undefined,
  class: undefined,
  style: undefined,
  attr: undefined,
};

export const defaultIconContext: React.Context<IconContext> = React.createContext && React.createContext(defaultContext);

// denoCacheMetadata={"headers":{"accept-ranges":"bytes","content-type":"text/plain; charset=utf-8","access-control-allow-origin":"*","alt-svc":"h3=\":443\";ma=86400,h3-29=\":443\";ma=86400,h3-27=\":443\";ma=86400","x-jsd-version":"1.0.8","date":"Tue, 25 Feb 2025 17:37:34 GMT","x-served-by":"cache-fra-etou8220096-FRA, cache-iad-kiad7000112-IAD","access-control-expose-headers":"*","etag":"W/\"32a-Bmotoc1mE42JAxp+yFUNnwalsPg\"","cross-origin-resource-policy":"cross-origin","cache-control":"public, max-age=31536000, s-maxage=31536000, immutable","x-content-type-options":"nosniff","timing-allow-origin":"*","strict-transport-security":"max-age=31536000; includeSubDomains; preload","age":"1200166","x-jsd-version-type":"version","x-cache":"HIT, HIT","vary":"Accept-Encoding"},"url":"https://cdn.jsdelivr.net/gh/urielch/react-icons@1.0.8/lib/iconContext.ts","time":1740505054}